module.exports = __webpack_public_path__ + "static/media/icon_toeic.57165742.svg";